module.exports = __webpack_public_path__ + "static/media/RiceBowlSteak.9479e6d5.jpg";